<div>

  <div class="checkBoxesSection">
    <div
      class="needBracketSection"
    >
      <input
        id="need_bracket_checkbox"
        type='checkbox'
        [checked]="gridIsRequired()"
        (click)="gridRequiredClickHandler()"
      >
      <div
        class="needBracketLabel"
      >
        Нужна сетка
      </div>
    </div>
    <div
      *ngIf="gridIsRequired()"
      class="thirdPlaceCheckBoxSection"
    >
      <input
        id="thirdPlaceTournamentCheckBox"
        type="checkbox"
        [checked]="getThirdPlaceTournamentAvailable()"
        (click)="setThirdPlaceTournamentAvailable()"
      >
      <div
        class="thirdPlaceTournamentCheckBoxLabel"
      >
        Нужен матч за третье место
      </div>
    </div>
  </div>

  <div
    *ngIf="gridIsRequired()"
  >
    <div
      class="groupsParameterInputSection"
    >
      <div
        class="groupParameterLabel"
      >
        Число групп:
      </div>
      <div>
        <input
          id="group_amount_input"
          class="inputSize"
          (focus)="disableConventionalGridTypesList()"
          maxlength="3"
          [ngModel]="getGroupsAmount()"
          (ngModelChange)="setGroupsAmount($event)"
          (keyup)="inputValueFilter($event)"
          title="Целое положительное число"
        >
        <div
          [ngClass]="messageStyle(getGroupsAmount())"
        >
          {{
          messageToDisplay(
            !permittedGroupsAmount(),
            groupsMaximalAmount,
            getGroupsAmount())
          }}
        </div>
      </div>
    </div>

    <div
      class="groupsParameterInputSection"
    >
      <div
        class="groupParameterLabel"
      >
        Выходит из группы:
      </div>
      <div>
        <input
          id="players_leaving_groups_input"
          class="inputSize"
          (focus)="disableConventionalGridTypesList()"
          maxlength="3"
          [ngModel]="getPlayersLeavingGroupsNumber()"
          (ngModelChange)="setPlayersLeavingGroupsNumber($event)"
          (keyup)="inputValueFilter($event)"
          title="Количество игроков, выходящих из группы"
        >
        <div
          [ngClass]="messageStyle(getPlayersLeavingGroupsNumber())"
        >
          {{
          messageToDisplay(
            !permittedPlayersLeavingGroupNumber(),
            playersExitingGroupsMaximalNumber,
            getPlayersLeavingGroupsNumber()
          )
          }}
        </div>
      </div>
      <div
        class="chooseGridButtonSection"
      >
        <button
          id="choose_bracket_with_groups_button"
          [ngClass]="chooseGridTypeButtonStyle()"
          (click)="handleChooseGridTypeButtonClick()"
        >
          Выбрать сетку
        </button>
      </div>
    </div>

  </div>

  <div
    *ngIf="!gridIsRequired()"
    class="createWithoutGroupsButtonSection"
  >
    <button
      id="create_group_only_button"
      class="createWithoutGroupsButton"
      (click)="handleGroupsOnlyClick()"
    >
      Создать групповой турнир без сетки
    </button>
  </div>


</div>
